function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import _ from "lodash";
import TitleButtonHd from "@pt/components/title-button-hd/index.vue";
import { defineComponent, onMounted, onBeforeUnmount, watch, // reactive,
computed, ref, // unref,
getCurrentInstance } from "vue";
import { ListType } from "./type";
import { definePropType } from "@types-vue/props";
import SearchFilter from "@pt/components/search-filter/index.vue";
export default defineComponent({
    props: {
        allFont: {
            type: definePropType(Array),
            required: true
        },
        assistTag: {
            type: definePropType(Array),
            required: true
        },
        currentFont: {
            type: definePropType(Array),
            required: true
        },
        systemFont: {
            type: definePropType(Array),
            required: true
        },
        assetFont: {
            type: definePropType(Array),
            required: true
        },
        currentGroup: {
            type: definePropType(Object),
            required: true
        },
        type: {
            type: definePropType(Number),
            default: ListType.ALL
        },
        langConfig: {
            type: definePropType(Object),
            required: true
        },
        offsetConfig: {
            type: definePropType(Object)
        },
        fontSelectorLoading: {
            type: Boolean,
            default: false
        },
        listLoading: {
            type: Boolean,
            default: false
        },
        layerDialogConfig: {
            type: Object,
            default: function() {}
        },
        assetFontConfig: {
            type: definePropType(Object)
        },
        customUpdateDialog: definePropType(Function)
    },
    components: {
        TitleButtonHd: TitleButtonHd,
        SearchFilter: SearchFilter
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var updatePosition = function updatePosition() {
            if (visible.value && props.customUpdateDialog) {
                var offsetStyle = _objectSpread({}, props.offsetConfig);
                updateDialogPosition(offsetStyle);
            }
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var dialogConfig = _objectSpread({
            modal: false,
            top: "0",
            width: "312px",
            appendToBody: true
        }, props.layerDialogConfig);
        var layerDialog = ref(null);
        var searchFilterRef = ref(null);
        var visible = ref(false);
        var keyword = ref("");
        var tagList = ref([]);
        var selectFont = ref("");
        var tabList = [
            {
                text: props.langConfig.title
            }, 
        ];
        var searchOptions = computed(function() {
            var temp = _.cloneDeep(props.assistTag);
            var options = [];
            temp.forEach(function(item) {
                item.option = item.sub_tags;
                delete item.sub_tags;
                options.push(item);
            });
            return options;
        });
        var currentFontItem = computed(function() {
            if (props.currentFont[0]) {
                return props.currentFont[0];
            }
            return {
                name: "",
                file_url: "",
                postscript_name: ""
            };
        });
        var updateDialogPosition = function(config) {
            var left = config.left, right = config.right, top = config.top, bottom = config.bottom, height = config.height;
            var dialog = _.get(layerDialog.value, "$refs.dialog");
            if (props.customUpdateDialog) {
                props.customUpdateDialog(dialog, config);
                return;
            }
            var dialogBody = dialog.getElementsByClassName("el-dialog__body")[0];
            if (dialog) {
                var isSet = function(val) {
                    return Boolean(val) || val === 0;
                };
                var isAuto = function(val) {
                    return val === "auto" || val === "15vh";
                };
                // dialog.style.top = isSet(Number(top)) ? top + 'px' : '88px'
                dialog.style.left = isSet(Number(left)) ? left + "px" : "auto";
                // dialog.style.right = isSet(Number(right)) ? right + 'px' : '328px'
                dialog.style.bottom = isSet(Number(bottom)) ? bottom + "px" : "auto";
                if (isAuto(String(top))) {
                    dialog.style.top = top;
                } else if (isSet(Number(top))) {
                    dialog.style.top = top + "px";
                } else {
                    dialog.style.top = "88px";
                }
                if (isAuto(String(right))) {
                    dialog.style.right = right;
                } else if (isSet(Number(right))) {
                    dialog.style.right = right + "px";
                } else {
                    dialog.style.right = "328px";
                }
                if (dialogBody && height) {
                    dialogBody.style.height = height;
                }
            }
        };
        var isTagSearch = computed(function() {
            return props.currentGroup.id !== 0 || keyword.value !== "" || tagList.value.length > 0;
        });
        var getAssetFont = function(assetFont) {
            // 首页展示4个
            return assetFont.filter(function(item, index) {
                return index < 4;
            });
        };
        var handleClickGroup = function(group) {
            emit("update-group", group);
        };
        var handleClickAssetGroup = function() {
            emit("update-asset-group");
        };
        var resetState = function() {};
        var updateKeyword = function(val) {
            emit("update-keyword", val);
        };
        var handleApply = function(tags) {
            tagList.value = tags.value;
            emit("update-filter", tags.value);
        };
        var handleSelectFont = function(font) {
            // if (props.fontSelectorLoading) {
            //   return
            // }
            selectFont.value = font.postscript_name || "";
            emit("select-font", font);
        };
        var resetFilter = function() {
            var _$ref;
            keyword.value = "";
            tagList.value = [];
            (_$ref = searchFilterRef.value) === null || _$ref === void 0 ? void 0 : _$ref.clearAll();
        };
        var switchVisible = function() {
            visible.value = !visible.value;
        };
        watch(function() {
            return visible.value;
        }, function(val) {
            if (val) {
                selectFont.value = currentFontItem.value.postscript_name || "";
            }
            emit("input", val);
            root.$nextTick(function() {
                var offsetStyle = _objectSpread({}, props.offsetConfig);
                updateDialogPosition(offsetStyle);
            });
        }, {
            immediate: true
        });
        watch(function() {
            return currentFontItem.value.postscript_name;
        }, function(val) {
            selectFont.value = val || "";
        }, {
            deep: true
        });
        onMounted(function() {
            window.addEventListener("resize", updatePosition);
        });
        onBeforeUnmount(function() {
            window.removeEventListener("resize", updatePosition);
        });
        return {
            isTagSearch: isTagSearch,
            selectFont: selectFont,
            currentFontItem: currentFontItem,
            tagList: tagList,
            searchFilterRef: searchFilterRef,
            tabList: tabList,
            layerDialog: layerDialog,
            visible: visible,
            dialogConfig: dialogConfig,
            searchOptions: searchOptions,
            keyword: keyword,
            switchVisible: switchVisible,
            resetFilter: resetFilter,
            updateDialogPosition: updateDialogPosition,
            resetState: resetState,
            updateKeyword: updateKeyword,
            handleApply: handleApply,
            handleClickGroup: handleClickGroup,
            handleClickAssetGroup: handleClickAssetGroup,
            handleSelectFont: handleSelectFont,
            getAssetFont: getAssetFont
        };
    }
});
